export default __webpack_public_path__ + "static/media/BrutalType-Bold.b1ad6f75.woff2";